// Setup do i18next + react-i18next. Importado por `src/app/root.tsx` antes
// do `createRoot` — recursos sao bundled (sem suspense fallback necessario).
//
// Detector de idioma:
//   1. localStorage (`granamoney_lang`) — preferencia explicita do usuario.
//   2. navigator.language — default do browser.
//   - Cache em localStorage para persistir entre sessoes.
//
// Fallback chain: `pt-BR -> en`. Locale primario: `pt-BR`. Adicionar locales
// novos requer 3 passos: `locales/<code>.ts` (com Translations type), import
// aqui, registro em `resources` + `supportedLngs`.

import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import { en } from './locales/en';
import { ptBR } from './locales/pt-BR';

// `void` porque init() retorna Promise mas nao queremos bloquear o boot
// (recursos sao bundled — disponivel sincronamente assim que i18n inicializa).
void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'pt-BR',
    supportedLngs: ['pt-BR', 'en'],
    resources: {
      'pt-BR': { translation: ptBR },
      en: { translation: en },
    },
    interpolation: {
      // React ja escapa por default; double-escape causa "&amp;" em strings.
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'granamoney_lang',
      caches: ['localStorage'],
    },
    // Em testes (Vitest) nao queremos warnings de fallback verbose.
    debug: false,
  });

export { i18n };
